import { Injectable } from '@angular/core';

declare function showError(messages: string[], stacktrace?: string, title?: string): void;

@Injectable({
  providedIn: 'root'
})
export class ErrorAlertService {
  showError(messages: string[], stackTrace: string = null, title: string = null) {
    if (typeof showError === 'function') {
      showError(messages, stackTrace, title);
    } else {
      alert(JSON.stringify({ title, messages, stackTrace }, null, 2));
    }
  }
}
